<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="480px">
        <ChangePasswordForm @close="closeResponse"></ChangePasswordForm>
      </v-dialog>
      <!-- <Snackbars :isShow="isShow" :testDisplay="textDisplay"></Snackbars> -->
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
import ChangePasswordForm from "../../components/ChangePasswordForm.vue";
export default {
  name: "ChangePasswordDialog",
  components: {
    ChangePasswordForm,
  },
  data() {
    return {

    };
  },

  props: ["dialog"],

  methods: {

    closeResponse() {
      // this.$refs.form.reset();
      this.$emit("close", true);
    },

    // formatDate(d) {
    //   return moment(d).format("YYYY-MM-DD HH:mm:ss");
    // },
  },
  computed: {
    // startDateDisp() {
    //   return this.form.promo_startdate;
    //   // format/do something with date
    // },
    // endDateDisp() {
    //   return this.form.promo_enddate;
    //   // format/do something with date
    // },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },

  watch: {
    // dialog() {
    //   if (this.$props.actionType === "EDIT") {
    //     setTimeout(() => {
    //       const currentData = this.$props.data;
    //       const form = this.form;

    //       Object.keys(form)
    //         .filter((key) => key in currentData)
    //         .forEach((key) => {
    //           form[key] = currentData[key];
    //         });
    //     }, 500);
    //   } else {
    //     const form = this.form;

    //     Object.keys(form).forEach((key) => {
    //       form[key] = "";
    //     });
    //   }
    // },
  },
};
</script>
